import { ITransactionsContext, ITransactionsState } from "./TransactionsProviderTypes";

export const TRANSACTIONS_INITIAL_CONTEXT: ITransactionsContext = {
  transactions: {
    data: [],
    itemCount: 0,
    skip: 0,
    take: 10
  },
  query: {
    pageIndex: 1,
    pageSize: 10,
    sortBy: "id"
  },
  searchValue: "",
  handlePaginationClick: () => {},
  handleSearchChange: () => {},
  refundTransaction: () => {},
  refundTransactionLoading: false
}

export const TRANSACTIONS_INITIAL_STATE: ITransactionsState = {
  transactions: {
    data: [],
    itemCount: 0,
    skip: 0,
    take: 10
  },
  query: {
    pageIndex: 1,
    pageSize: 10,
    sortBy: "id"
  },
  searchValue: "",
  handleSearchChange: () => {}
}